export function HandoverBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;
  let companyId = context.companyId;
  let siteId = context.site.id;
  let scenarioId = context.scenarioId;
  let hasTargetAppId = siteTypeConfig.hasTargetAppId;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: [
      '<div class="html-element handover-box">',
      '  <div class="question-text-content-container">',
      '    <div class="handover-box-text">' + services.$translate.instant('parameters/quick_replies/details/handover_box/help_text') + '</div>',
      '    <div class="handover-edit-container"><span class="glyphicon glyphicon-pencil handover-edit"></span></div>',
      '  </div>',
      '  <button class="add-condition center-block btn btn-alcmeon-default">',
          services.$translate.instant('parameters/quick_replies/details/add_a_condition'),
      '  </button>',
      '</div>'
    ].join(''),

    initialize: function() {

      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.handover-edit').on('click', () => this.editHandover());
      this.$box.find('.add-condition').on('click', () => this.addHandoverItem());
    },

    /**
     * Event handler that shows a modal
     * for editing the bot id and the metadata string that we must be sent to trigger it
     */
    editHandover : function() {
      let modalInstance = services.$uibModal.open({
        animation: true,
        template:  require('./editHandover.modal.html'),
        controller: 'editHandoverController',
          resolve: {
            controllerParams: () => { return {
              target_app_id: this.model.get('target_app_id'),
              thread_control_metadata: this.model.get('thread_control_metadata'),
              timeout:  this.model.get('timeout'),
              companyId: companyId,
              siteId: siteId,
              scenarioId: scenarioId,
              hasTargetAppId: hasTargetAppId
            }}
          }
      });
      // Hook callback that will update the model and save the updated graph
      modalInstance.result.then(result => {
        if (result.type === 'edit') {
          this.model.set('target_app_id', result.data.target_app_id);
          this.model.set('thread_control_metadata', result.data.thread_control_metadata);
        }
        this.setHandoverHtmlContent();
        callbacks.updateSerializedGraph(this.model.graph);
      });
    },

    /**
     * Creates a new HandoverItem, of type 'custom'
     * (there msut be one and onyl one 'timeout' condition, hence it is not possible to add any)
     */
    createHandoverItem: function (id) {
      let handover = this.model;
      let item = new joint.shapes.html.HandoverItem({
        id: id,
        handoverType: 'custom',
        description: '',
        data: ''
      });
      handover.embed(item);
      handover.graph.addCell(item);
      this.resizeBox();

      return item;
    },

    /**
     * Adds a new handover item with a new id;
     *  called on a add button click.
     */
    addHandoverItem: function(evt) {
      services.QuickRepliesFactory.createUniqueId(companyId, siteId, scenarioId)
        .then(response => {
          this.createHandoverItem(response.data.id);
        }, response => {
          services.AlertingFactory.alertHTTPError(response);
        });
    },

    setHandoverHtmlContent: function() {
      // Update text content
      this.$box.find('.handover-box-text').text(this.model.get('content'));
    },

    resizeBox: function resizeBox() {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('HandoverBoxView - resizeBox()');
      }
      let box = this.model;
      let embeddedCells = box.getEmbeddedCells();
      let paddingTop = this.$box.find('.handover-box-text').outerHeight();
      let paddingBottom = this.$box.find('.add-condition').outerHeight();

      //Reposition and resize every item
      let ypos = paddingTop ;
      for(let child of embeddedCells) {
        let childView = this.paper.findViewByModel(child);
        child.position(0, ypos, {parentRelative: true});
        let childHeight = childView.$box.outerHeight();
        child.resize(box.attributes.size.width, childHeight);
        ypos += childHeight;
      }

      box.fitEmbeds({padding: {top: paddingTop, right: 0, bottom: paddingBottom, left: 0}});
      callbacks.resizePaper();
    }
  });
}
